export enum PageTitles {
	PasswordRecovery = "Восстановление пароля",
	SetNewPassword = "Новый пароль",
	Penalty = "Штрафы",
	TollRoads = "Платные дороги",
}
